import Dashboard from "../../common/components/layout/Dashboard";
import Toast from "../../common/components/ui/toast";
import { ToastProvider } from "../../common/components/ui/toast/toast.provider";
import TableCollision from "./table-collision/TableCollision";
function Collision() {
    return (
        <ToastProvider>
            <Dashboard>
                <TableCollision />
            </Dashboard>
            <Toast />
        </ToastProvider>
    );
}
export default Collision;
